export default __webpack_public_path__ + "static/media/emc-1.5109cf3b.png";